module.exports = __webpack_public_path__ + "static/media/wizualizacja-129.b9e0d760.png";